import { useState } from "react";
import styled from "styled-components";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import { useModal } from "../../contexts/ModalContext";
import { useToast } from "../../contexts/ToastContext";
import useApi from "../../hooks/useApi";

export const MODAL_ENVIAR_PASSAGENS = "enviarPassagensModal";

const Titulo = styled.h2`
    margin: 0 0 10px 0;
    font-size: 17px;
    color: #263b4b;
    text-align: center;
`;

const Subtitulo = styled.p`
    margin: 0;
    font-size: 14px;
    color: #555;
    text-align: center;
    line-height: 1.5;
`;

const Resumo = styled.div`
    margin: 16px 0 0 0;
    padding: 12px;
    background-color: #f5f7fa;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    font-size: 13px;
    color: #111;

    p {
        margin: 0;
    }

    b {
        color: #263b4b;
    }
`;

const Campo = styled.div`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 6px;

    label {
        font-size: 12px;
        font-weight: 700;
        color: #64748b;
    }

    input {
        padding: 10px 12px;
        border: 1px solid #94a3b8;
        border-radius: 8px;
        font-size: 14px;
        outline: none;

        &:focus {
            border-color: #2563eb;
            box-shadow: 0 0 0 1px #2563eb;
        }
    }
`;

const BotoesWrapper = styled.div`
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`;

const Botao = styled.button`
    padding: 9px 16px;
    background-color: ${(p) => (p.$cancel ? "#e5e7eb" : "#263B4B")};
    color: ${(p) => (p.$cancel ? "#333" : "white")};
    border: none;
    border-radius: 6px;
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover:not(:disabled) {
        background-color: ${(p) => (p.$cancel ? "#d1d5db" : "#1d2f3d")};
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

const ModalEnviarPassagens = ({ ids, onSuccess }) => {

    const api = useApi();
    const { closeModal } = useModal();
    const { notifyError, notifySuccess } = useToast();

    const [email, setEmail] = useState("");
    const [enviando, setEnviando] = useState(false);

    const handleClose = () => {
        closeModal(MODAL_ENVIAR_PASSAGENS);
    };

    const handleEnviar = async () => {
        const emailTrim = email.trim();

        if (!emailTrim || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailTrim)) {
            notifyError("Informe um e-mail válido.");
            return;
        }

        if (!Array.isArray(ids) || ids.length === 0) {
            notifyError("Nenhuma solicitação selecionada.");
            return;
        }

        setEnviando(true);

        try {
            const { data } = await api.post("/Painel/API/SolicitacaoPassagem/Enviar/", {
                ids,
                email: emailTrim
            });

            if (!data?.success) {
                notifyError(data?.message || "Não foi possível enviar as passagens.");
                return;
            }

            notifySuccess(data.message || "Passagens enviadas com sucesso.");
            if (typeof onSuccess === "function") {
                await onSuccess();
            }
            handleClose();
        } catch (err) {
            console.error(err);
            notifyError(err?.response?.data?.message || "Erro ao enviar as passagens.");
        } finally {
            setEnviando(false);
        }
    };

    return (
        <Overlay state>
            <Modal size="sm" header close={handleClose}>
                <Titulo>Enviar passagens</Titulo>
                <Subtitulo>
                    Confirma o envio das passagens selecionadas por e-mail e a alteração do status para <b>INSERIR VALORES</b>?
                </Subtitulo>

                <Resumo>
                    <p>
                        <b>QUANTIDADE:</b> {ids?.length || 0}
                    </p>
                </Resumo>

                <Campo>
                    <label>E-MAIL DESTINATÁRIO</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="email@exemplo.com"
                        disabled={enviando}
                    />
                </Campo>

                <BotoesWrapper>
                    <Botao type="button" $cancel onClick={handleClose} disabled={enviando}>
                        CANCELAR
                    </Botao>
                    <Botao type="button" onClick={handleEnviar} disabled={enviando}>
                        {enviando ? "ENVIANDO…" : "CONFIRMAR ENVIO"}
                    </Botao>
                </BotoesWrapper>
            </Modal>
        </Overlay>
    )

}

export default ModalEnviarPassagens;
